import { type AvailableRoutePath } from '@/router'
import { useMatches } from '@tanstack/react-router'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { type FC, type PropsWithChildren, type ReactNode, useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

export interface SideBarItemGroupProps {
  icon: ReactNode
  label: string
  matchingPaths: AvailableRoutePath[]
}

export const SideBarItemGroup: FC<PropsWithChildren<SideBarItemGroupProps>> = ({
  icon,
  label,
  children,
  matchingPaths,
}) => {
  const matches = useMatches()

  const [isExpanded, setIsExpanded] = useState(false)

  const handleClickMenuGroupButton = () => {
    setIsExpanded((prev) => !prev)
  }

  // Check if any of the matchingPaths are active
  const isAnyPathActive = matchingPaths.some((matchingPath) => matches.some((match) => match.pathname === matchingPath))

  useEffect(() => {
    if (isAnyPathActive) {
      setIsExpanded(true)
    }
  }, [isAnyPathActive])

  return (
    <div className={cn('flex flex-col')}>
      <button
        className={cn(
          'flex items-center space-x-2',
          'px-4 py-2',
          'text-sm font-medium text-foreground',
          'hover:cursor-pointer'
        )}
        onClick={handleClickMenuGroupButton}
      >
        <span className={cn('aspect-square w-4')}>{icon}</span>
        <span className={cn('grow', 'text-left')}>{label}</span>
        {isExpanded && <ChevronUpIcon size={16} />}
        {!isExpanded && <ChevronDownIcon size={16} />}
      </button>
      {isExpanded && <div className={cn('[&>*]:block', 'space-y-1', 'pl-7 pt-1', 'origin-top')}>{children}</div>}
    </div>
  )
}
